import { render, staticRenderFns } from "./ProductionSound.vue?vue&type=template&id=74d25db7&scoped=true&"
import script from "./ProductionSound.vue?vue&type=script&lang=js&"
export * from "./ProductionSound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d25db7",
  null
  
)

export default component.exports